import type { DocumentResult } from './desktop-api';

/** What a folder analysis's sample document must carry for its reading to be judged. */
export type FolderAnalysisDocument = Pick<
  DocumentResult,
  'sourcePath' | 'sourcePaths' | 'pages' | 'notReadReason'
>;

const hasFailureReason = (reason: string | null | undefined): boolean => Boolean(reason?.trim());

/**
 * A representative document is evidence only when both native reading lanes
 * answered for every page. An empty page list is not a blank document; it is no
 * proof that the selected source reached either reader. Shared by the main
 * process's folder-analysis evidence and the renderer's setup samples
 * (setup-sample-leave-out.ts), so both judge a sample read the same way.
 */
export const folderAnalysisDocumentWasRead = (
  document: Pick<FolderAnalysisDocument, 'pages' | 'notReadReason'>,
): boolean =>
  document.pages.length > 0 &&
  !hasFailureReason(document.notReadReason) &&
  document.pages.every((page) => !hasFailureReason(page.notReadReason));
